import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const SentimentSatisfiedIcon = (props: SvgIconProps) => (
  <SvgIcon width="28" height="28" viewBox="0 0 28 28" {...props}>
    <path
      opacity="0.2"
      d="M14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.20101 19.799 3.5 14 3.5C8.20101 3.5 3.5 8.20101 3.5 14C3.5 19.799 8.20101 24.5 14 24.5Z"
      fill="white"
    />
    <path
      d="M10.0625 13.125C10.7874 13.125 11.375 12.5374 11.375 11.8125C11.375 11.0876 10.7874 10.5 10.0625 10.5C9.33763 10.5 8.75 11.0876 8.75 11.8125C8.75 12.5374 9.33763 13.125 10.0625 13.125Z"
      fill="white"
    />
    <path
      d="M17.9375 13.125C18.6624 13.125 19.25 12.5374 19.25 11.8125C19.25 11.0876 18.6624 10.5 17.9375 10.5C17.2126 10.5 16.625 11.0876 16.625 11.8125C16.625 12.5374 17.2126 13.125 17.9375 13.125Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0007 4.66683C8.84599 4.66683 4.66732 8.8455 4.66732 14.0002C4.66732 19.1548 8.84599 23.3335 14.0007 23.3335C19.1553 23.3335 23.334 19.1548 23.334 14.0002C23.334 8.8455 19.1553 4.66683 14.0007 4.66683ZM2.33398 14.0002C2.33398 7.55684 7.55733 2.3335 14.0007 2.3335C20.444 2.3335 25.6673 7.55684 25.6673 14.0002C25.6673 20.4435 20.444 25.6668 14.0007 25.6668C7.55733 25.6668 2.33398 20.4435 2.33398 14.0002ZM8.86481 15.6162C9.42207 15.2927 10.136 15.4822 10.4595 16.0395C10.8195 16.6597 11.336 17.1744 11.9575 17.5323C12.5789 17.8901 13.2834 18.0784 14.0005 18.0784C14.7176 18.0784 15.4221 17.8901 16.0435 17.5323C16.6649 17.1744 17.1815 16.6597 17.5415 16.0395C17.8649 15.4822 18.5789 15.2927 19.1362 15.6162C19.6934 15.9396 19.8829 16.6536 19.5595 17.2108C18.9944 18.1845 18.1834 18.9926 17.2078 19.5543C16.2322 20.1161 15.1262 20.4118 14.0005 20.4118C12.8747 20.4118 11.7687 20.1161 10.7931 19.5543C9.81754 18.9926 9.00661 18.1845 8.44147 17.2108C8.11801 16.6536 8.30755 15.9396 8.86481 15.6162Z"
      fill="white"
    />
  </SvgIcon>
);
